import { Link } from "react-router-dom";
import { pushEvent } from "@/utils/dataLayer";

const EvidenceSection = () => (
  <section className="evidence-section">
    <div className="container">
      <span className="section-label">02 — EVIDENCE</span>
      <h2 className="method-title text-left text-white font-black uppercase mb-20 mt-10" style={{ lineHeight: 0.9 }}>
        REAL BUSINESSES.<br />REAL CONSTRAINTS.
      </h2>
      <p className="evidence-lead">
        Real businesses have real constraints.<br />
        <strong className="text-white">The website has to match them.</strong>
      </p>

      <div className="border-t border-void-border-strong pt-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          {[
            { label: "01 // ORGANIC", value: "0 → 100K", desc: "Monthly visitors built on structure." },
            { label: "02 // EFFICIENCY", value: "10+ HRS", desc: "Saved per week via automated layout." },
            { label: "03 // SUPPORT", value: "-40%", desc: "Reduction in basic support queries." },
          ].map((metric) => (
            <div key={metric.label}>
              <span className="font-mono text-xs font-bold tracking-widest uppercase text-primary">
                {metric.label}
              </span>
              <p className="text-5xl lg:text-6xl font-black mt-4 mb-4 tracking-tight font-display text-white">
                {metric.value}
              </p>
              <p className="text-void-muted leading-relaxed">{metric.desc}</p>
            </div>
          ))}
        </div>

        {/* Manufacturer Teaser */}
        <div className="border-l-2 border-l-primary bg-void-card p-8 lg:p-10 mb-16">
          <span className="font-mono text-xs font-bold uppercase tracking-widest text-primary block mb-6">
            CASE — MANUFACTURER
          </span>
          <p className="text-sm text-void-muted leading-relaxed mb-4 normal-case">
            A manufacturer masquerading as a reseller, leaking authority through poor website structure.
          </p>
          <p className="text-sm leading-relaxed mb-4 normal-case text-void-text-bright">
            Repositioned the brand to reflect the stature of the business and made critical information effortless to find.
          </p>
          <p className="text-sm font-bold text-white leading-relaxed mb-6 normal-case">
            The website now reinforces the business behind it.
          </p>
          <Link to="/systems" className="font-mono text-xs font-bold uppercase tracking-widest text-void-muted hover:text-primary transition-colors" onClick={() => pushEvent('cta_click', { label: 'SEE THE CASE', location: 'evidence' })}>
            SEE THE CASE →
          </Link>
        </div>

        <Link to="/systems" className="bridge-cta" onClick={() => pushEvent('cta_click', { label: 'ENTER THE DATA ROOM', location: 'evidence' })}>
          ENTER THE DATA ROOM →
        </Link>
      </div>
    </div>
  </section>
);

export default EvidenceSection;
